export default __webpack_public_path__ + "static/media/error.7718967c.svg";